module.exports = __webpack_public_path__ + "img/62feeaf.png";